var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _g, _path156, _path157, _path158, _path159, _path160, _path161, _g2, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrototyping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 228,
    viewBox: "0 0 306 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305.984 190.51H0.654297V190.644H305.984V190.51Z",
    fill: "#C5E0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M259.306 196.122H226.898V196.255H259.306V196.122Z",
    fill: "#DCEAF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202.917 198.513H167.096V198.647H202.917V198.513Z",
    fill: "#DCEAF8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220.558 198.513H208.84V198.647H220.558V198.513Z",
    fill: "#DCEAF8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3822 196.122H62.0078V196.255H88.3822V196.122Z",
    fill: "#DCEAF8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6063 195.052H49.1777V195.185H58.6063V195.052Z",
    fill: "#DCEAF8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114.035 198.379H80.9375V198.513H114.035V198.379Z",
    fill: "#DCEAF8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5546 88.9317H44.1761L42.9609 87.5408H49.7637L48.5546 88.9317Z",
    fill: "#263238"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2773 71.8772C55.2733 72.9755 55.0046 74.0606 54.489 75.0618C53.9734 76.0629 53.2224 76.9574 52.2851 77.6868C51.6577 78.1626 51.1526 78.7495 50.8031 79.4088C50.4536 80.0681 50.2677 80.7849 50.2577 81.5118V82.1056H42.4718V81.5118C42.4617 80.7862 42.2763 80.0707 41.9279 79.4124C41.5796 78.7541 41.0761 78.1678 40.4505 77.6922C39.067 76.6184 38.099 75.1943 37.6805 73.6171C37.2621 72.0398 37.414 70.3877 38.1151 68.8895C38.8162 67.3912 40.0319 66.1211 41.5937 65.2551C43.1555 64.3891 44.9861 63.9701 46.8319 64.0561C49.1105 64.1757 51.2516 65.0507 52.8203 66.5034C54.3889 67.9561 55.2675 69.8775 55.2773 71.8772Z",
    fill: "#FFD34D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2277 73.9903L42.7012 74.0845L44.5727 82.1144L45.0992 82.0202L43.2277 73.9903Z",
    fill: "#F0F7FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5042 73.9954L47.6406 82.0267L48.1672 82.1205L50.0308 74.0892L49.5042 73.9954Z",
    fill: "#F0F7FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4428 77.5317L46.368 75.8198L45.2811 77.5317L43.2598 75.4881L43.6628 75.1832L45.1833 76.7132L46.368 74.8462L47.5466 76.7132L49.0671 75.1832L49.4702 75.4881L47.4428 77.5317Z",
    fill: "#F0F7FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2586 82.0682V87.5034L42.4727 87.5408V82.1056L50.2586 82.0682Z",
    fill: "#FFD34D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2543 87.2649L42.4746 87.3054L42.4778 87.7761L50.2575 87.7357L50.2543 87.2649Z",
    fill: "#F0F7FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2543 81.8352L42.4746 81.8756L42.4778 82.3464L50.2575 82.3059L50.2543 81.8352Z",
    fill: "#F0F7FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M234.708 213.074H203.027L213.213 221.174H245.89L234.708 213.074Z",
    fill: "#C5E0FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M198.801 225.336L175.291 214.332L194.893 208.03L217.665 217.873L198.801 225.336Z",
    fill: "#F0F7FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M179.56 210.571H207.828L199.278 219.826H167.945L179.56 210.571Z",
    fill: "#B3CCE5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M257.034 33.8041C263.627 33.8041 268.973 29.1217 268.973 23.3457C268.973 17.5696 263.627 12.8872 257.034 12.8872C250.441 12.8872 245.096 17.5696 245.096 23.3457C245.096 29.1217 250.441 33.8041 257.034 33.8041Z",
    fill: "#98B2CB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M257.065 34.0395C253.826 34.0395 250.719 32.9123 248.429 30.9058C246.138 28.8993 244.852 26.1779 244.852 23.3403C244.852 20.5027 246.138 17.7813 248.429 15.7748C250.719 13.7683 253.826 12.6411 257.065 12.6411V13.1119C253.97 13.1119 251.002 14.1889 248.813 16.1061C246.625 18.0233 245.395 20.6236 245.395 23.335C245.395 26.0463 246.625 28.6466 248.813 30.5638C251.002 32.481 253.97 33.558 257.065 33.558V34.0395Z",
    fill: "#F0F7FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M257.064 34.0395V33.5687C258.597 33.5687 260.114 33.3043 261.53 32.7905C262.946 32.2768 264.233 31.5237 265.316 30.5744C266.4 29.6251 267.259 28.4982 267.846 27.2578C268.432 26.0175 268.734 24.6882 268.734 23.3456C268.734 22.0031 268.432 20.6738 267.846 19.4334C267.259 18.1931 266.4 17.0661 265.316 16.1168C264.233 15.1675 262.946 14.4145 261.53 13.9007C260.114 13.387 258.597 13.1226 257.064 13.1226V12.6518C260.304 12.6518 263.41 13.779 265.7 15.7855C267.991 17.792 269.278 20.5134 269.278 23.351C269.278 26.1886 267.991 28.91 265.7 30.9165C263.41 32.9229 260.304 34.0502 257.064 34.0502V34.0395Z",
    fill: "#F0F7FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M263.305 23.3457H262.768C262.768 19.8791 260.759 15.2464 256.918 13.0851L257.211 12.6893C261.211 14.9415 263.305 19.7507 263.305 23.3457Z",
    fill: "#F0F7FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M257.211 33.6811L256.918 33.2852C260.759 31.1454 262.768 26.4912 262.768 23.03H263.305C263.305 26.6196 261.211 31.4342 257.211 33.6811Z",
    fill: "#F0F7FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M251.367 23.3457H250.83C250.83 19.7507 252.919 14.9361 256.937 12.6893L257.23 13.0851C253.377 15.241 251.367 19.8791 251.367 23.3457Z",
    fill: "#F0F7FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M256.917 33.6811C252.917 31.4343 250.811 26.6196 250.811 23.0247H251.348C251.348 26.4913 253.357 31.1294 257.192 33.2852L256.917 33.6811Z",
    fill: "#F0F7FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M257.332 12.8871H256.795V33.8041H257.332V12.8871Z",
    fill: "#F0F7FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M267.164 17.5359H246.957V18.0067H267.164V17.5359Z",
    fill: "#F0F7FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M268.995 23.2867H245.131V23.7575H268.995V23.2867Z",
    fill: "#F0F7FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M266.902 29.0323H247.227V29.503H266.902V29.0323Z",
    fill: "#F0F7FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M223.831 80.7094C223.835 74.6307 222.806 68.5855 220.778 62.7722L238.738 48.9328L227.453 31.7713L204.791 38.4903C195.265 29.5614 182.924 23.3143 169.336 20.5425L164.628 0H142.034L137.344 20.5425C123.751 23.3141 111.404 29.561 101.87 38.4903L79.1844 31.7713L67.875 48.9328L85.8345 62.7722C81.796 74.4723 81.796 86.9572 85.8345 98.6573L67.875 112.481L79.1844 129.642L101.846 122.928C111.387 131.853 123.73 138.104 137.319 140.892L142.009 161.435H164.604L169.312 140.892C182.896 138.104 195.233 131.853 204.767 122.928L227.428 129.642L238.738 112.481L220.778 98.6573C222.806 92.8402 223.835 86.7915 223.831 80.7094ZM153.319 114.053C146.072 114.053 138.988 112.171 132.963 108.644C126.937 105.117 122.241 100.104 119.468 94.239C116.695 88.374 115.969 81.9202 117.383 75.6939C118.797 69.4676 122.286 63.7483 127.41 59.2594C132.535 54.7705 139.063 51.7135 146.171 50.475C153.278 49.2365 160.645 49.8721 167.34 52.3015C174.035 54.7309 179.757 58.8449 183.783 64.1234C187.809 69.4018 189.958 75.6075 189.958 81.9558C189.958 90.4686 186.098 98.6328 179.227 104.652C172.355 110.672 163.036 114.053 153.319 114.053Z",
    fill: "#B3CCE5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M260.307 154.849C258.426 153.945 260.735 146.349 258.194 143.027C256.362 140.598 252.961 139.122 251.721 136.404C251.22 135.256 251.103 134.007 251.383 132.803C251.663 131.599 252.329 130.489 253.303 129.605C253.469 129.432 253.678 129.294 253.914 129.203C254.192 129.135 254.483 129.121 254.768 129.161C256.417 129.305 258.127 129.546 259.501 130.364C261.186 131.375 262.121 133.141 262.42 134.911C262.719 136.682 262.298 155.807 260.307 154.849Z",
    fill: "#009245"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M261.186 144.161C261.186 143.968 261.186 143.781 261.155 143.589C261.108 143.893 261.086 144.201 261.088 144.509L261.186 144.161Z",
    fill: "#98B2CB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M267.159 131.52C267.062 131.401 266.935 131.304 266.787 131.236C266.617 131.181 266.436 131.159 266.255 131.172C265.202 131.122 264.152 131.306 263.202 131.707C262.654 132.009 262.183 132.405 261.818 132.873C261.452 133.34 261.2 133.868 261.077 134.425C260.835 135.535 260.769 136.669 260.882 137.795L261.156 143.599C261.367 142.152 262.093 140.801 263.233 139.737C264.68 138.394 266.768 137.533 267.721 135.885C268.112 135.186 268.267 134.404 268.168 133.631C268.068 132.857 267.718 132.125 267.159 131.52Z",
    fill: "#009245"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M264.045 166.581C264.045 166.485 264.045 166.394 264.045 166.303C263.55 160.392 262.292 149.462 256.253 144.198C255.032 143.102 252.894 142.315 251.087 142.84C250.436 143.045 249.85 143.382 249.377 143.824C247.398 145.568 246.818 147.916 246.898 150.152C247.02 152.932 247.999 155.631 249.731 157.963C252.174 161.264 255.929 163.944 259.013 166.95C262.097 169.957 258.769 178.479 263.734 177.28C264.167 177.173 264.057 167.844 264.045 166.581Z",
    fill: "#009245"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M260.967 170.791C261.101 165.381 261.233 159.974 261.364 154.571C261.486 149.564 261.846 144.097 266.499 140.261C267.684 139.287 269.479 138.399 271.165 138.806C271.773 138.966 272.328 139.253 272.783 139.641C274.682 141.154 275.342 143.284 275.391 145.333C275.426 147.886 274.673 150.4 273.211 152.608C271.177 155.727 267.855 158.337 265.186 161.221C262.518 164.104 266.035 171.754 261.406 170.877L260.967 170.791Z",
    fill: "#009245"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M268.618 191.259C264.316 192.452 259.699 192.452 255.397 191.259L250.225 170.615H273.79L268.618 191.259Z",
    fill: "#012448"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M272.722 174.161H251.232V174.589H272.722V174.161Z",
    fill: "#F0F7FF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M153.319 227.508C218.71 227.508 271.72 224.796 271.72 221.452C271.72 218.107 218.71 215.396 153.319 215.396C87.9278 215.396 34.918 218.107 34.918 221.452C34.918 224.796 87.9278 227.508 153.319 227.508Z",
    fill: "#EBF5FF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M233.461 144.279H198.36C197.589 144.29 196.823 144.158 196.115 143.89C195.406 143.622 194.771 143.226 194.251 142.726C193.731 142.227 193.338 141.636 193.099 140.993C192.86 140.35 192.78 139.67 192.864 138.999L199.545 72.0804C199.713 70.6504 200.473 69.3239 201.682 68.3512C202.89 67.3784 204.463 66.8268 206.104 66.8004H241.204C241.976 66.7888 242.741 66.9212 243.45 67.1889C244.159 67.4565 244.794 67.8533 245.314 68.3528C245.834 68.8523 246.226 69.4431 246.465 70.0858C246.704 70.7285 246.784 71.4085 246.7 72.0804L240.032 138.999C239.863 140.43 239.102 141.758 237.891 142.731C236.68 143.704 235.104 144.255 233.461 144.279Z",
    fill: "url(#paint0_linear_1604_22911)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M233.461 144.279H198.36C197.589 144.29 196.823 144.158 196.115 143.89C195.406 143.622 194.771 143.226 194.251 142.726C193.731 142.227 193.338 141.636 193.099 140.993C192.86 140.35 192.78 139.67 192.864 138.999L199.545 72.0804C199.713 70.6504 200.473 69.3239 201.682 68.3512C202.89 67.3784 204.463 66.8268 206.104 66.8004H241.204C241.976 66.7888 242.741 66.9212 243.45 67.1889C244.159 67.4565 244.794 67.8533 245.314 68.3528C245.834 68.8523 246.226 69.4431 246.465 70.0858C246.704 70.7285 246.784 71.4085 246.7 72.0804L240.032 138.999C239.863 140.43 239.102 141.758 237.891 142.731C236.68 143.704 235.104 144.255 233.461 144.279Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M219.171 139.346C219.092 140.026 218.732 140.656 218.158 141.119C217.584 141.581 216.837 141.843 216.057 141.855C215.69 141.862 215.325 141.8 214.987 141.673C214.65 141.546 214.347 141.358 214.099 141.12C213.851 140.883 213.664 140.602 213.55 140.296C213.436 139.99 213.397 139.666 213.437 139.346C213.516 138.665 213.878 138.033 214.453 137.57C215.028 137.107 215.777 136.844 216.558 136.832C216.925 136.826 217.29 136.889 217.627 137.017C217.964 137.144 218.267 137.333 218.514 137.571C218.762 137.809 218.948 138.09 219.061 138.396C219.175 138.703 219.212 139.026 219.171 139.346Z",
    stroke: "#F0F7FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M228.759 72.7866H217.395C217.258 72.7888 217.122 72.7655 216.996 72.7181C216.87 72.6707 216.757 72.6004 216.665 72.5119C216.572 72.4233 216.503 72.3185 216.46 72.2045C216.417 72.0904 216.403 71.9697 216.418 71.8504V71.6204C216.446 71.3668 216.58 71.1312 216.794 70.9585C217.008 70.7859 217.287 70.6883 217.578 70.6842H228.942C229.079 70.682 229.215 70.7054 229.341 70.7527C229.467 70.8001 229.58 70.8704 229.672 70.959C229.765 71.0475 229.835 71.1523 229.877 71.2664C229.92 71.3804 229.934 71.5011 229.919 71.6204V71.8504C229.891 72.1041 229.757 72.3396 229.543 72.5123C229.329 72.6849 229.05 72.7826 228.759 72.7866Z",
    stroke: "#F0F7FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M236.99 133.13H196.559L202.262 76.0445H242.688L236.99 133.13Z",
    fill: "#F0F7FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M226.494 67.0411L206.916 144.279H218.683L238.06 67.0411H226.494Z",
    fill: "#F0F7FF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M217.339 67.0411L197.762 144.279H203.691L223.074 67.0411H217.339Z",
    fill: "#F0F7FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M209.413 130.043H199.416L200.021 123.993H210.011L209.413 130.043Z",
    fill: "url(#paint1_linear_1604_22911)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M222.09 130.043H212.094L212.698 123.993H222.695L222.09 130.043Z",
    fill: "url(#paint2_linear_1604_22911)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M234.774 130.043H224.777L225.382 123.993H235.378L234.774 130.043Z",
    fill: "url(#paint3_linear_1604_22911)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M236.319 114.604H200.955L200.9 115.139H236.264L236.319 114.604Z",
    fill: "url(#paint4_linear_1604_22911)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M236.319 114.604H200.955L200.9 115.139H236.264L236.319 114.604Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M236.521 112.561H233.26L233.547 109.699H236.808L236.521 112.561Z",
    fill: "url(#paint5_linear_1604_22911)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M220.486 112.561H217.225L217.512 109.699H220.773L220.486 112.561Z",
    fill: "url(#paint6_linear_1604_22911)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M204.448 112.561H201.188L201.474 109.699H204.735L204.448 112.561Z",
    fill: "url(#paint7_linear_1604_22911)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M235.756 120.2H226.48L226.676 118.237H235.952L235.756 120.2Z",
    fill: "url(#paint8_linear_1604_22911)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M224.766 106.591H201.799L202 104.601H224.967L224.766 106.591Z",
    fill: "url(#paint9_linear_1604_22911)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M224.766 106.591H201.799L202 104.601H224.967L224.766 106.591Z",
    fill: "#F0F7FF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M215.03 80.1797H204.436L204.649 78.0613H215.238L215.03 80.1797Z",
    fill: "url(#paint10_linear_1604_22911)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M215.03 80.1797H204.436L204.649 78.0613H215.238L215.03 80.1797Z",
    fill: "#F0F7FF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M203.111 121.591C202.751 121.597 202.394 121.535 202.064 121.41C201.733 121.286 201.437 121.101 201.194 120.868C200.951 120.635 200.768 120.36 200.656 120.06C200.545 119.761 200.507 119.444 200.546 119.13C200.624 118.464 200.977 117.846 201.54 117.392C202.102 116.939 202.835 116.682 203.6 116.669C203.959 116.664 204.316 116.725 204.647 116.85C204.977 116.974 205.274 117.159 205.517 117.392C205.759 117.625 205.942 117.9 206.054 118.2C206.166 118.5 206.203 118.817 206.164 119.13C206.087 119.796 205.733 120.415 205.171 120.868C204.608 121.322 203.875 121.579 203.111 121.591Z",
    fill: "url(#paint11_linear_1604_22911)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M237.425 102.996H202.141L204.272 81.6456H239.562L237.425 102.996Z",
    fill: "url(#paint12_linear_1604_22911)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M199.361 73.8565H212.222C213.721 73.8381 215.16 73.3373 216.265 72.4494C217.369 71.5616 218.063 70.3487 218.212 69.0419L218.432 66.8271H206.274C204.587 66.8532 202.969 67.4194 201.726 68.4187C200.483 69.4181 199.7 70.7815 199.526 72.2516L199.361 73.8565Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M247.215 83.7526L247.002 86.3297L247.611 86.3683L247.824 83.7912L247.215 83.7526Z",
    fill: "url(#paint13_linear_1604_22911)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M248.02 73.9941L247.402 81.4694L248.011 81.508L248.629 74.0328L248.02 73.9941Z",
    fill: "url(#paint14_linear_1604_22911)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M210.988 66.8486H107.408L113.148 9.3244H216.735L210.988 66.8486Z",
    fill: "url(#paint15_linear_1604_22911)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M209.56 71.3476H107.519C106.848 71.3588 106.182 71.2444 105.565 71.0121C104.948 70.7798 104.395 70.435 103.943 70.0006C103.49 69.5662 103.149 69.0522 102.941 68.493C102.733 67.9338 102.664 67.3421 102.738 66.7576L108.447 9.59182C108.591 8.34779 109.25 7.19297 110.3 6.34607C111.35 5.49917 112.718 5.01901 114.145 4.99652H216.217C216.888 4.98697 217.554 5.10263 218.17 5.33581C218.786 5.56899 219.339 5.91435 219.791 6.34897C220.243 6.78359 220.585 7.29751 220.793 7.85662C221.001 8.41572 221.071 9.00722 220.998 9.59182L215.288 66.7576C215.143 68.0052 214.479 69.1624 213.423 70.0088C212.367 70.8552 210.992 71.3317 209.56 71.3476Z",
    fill: "url(#paint16_linear_1604_22911)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M210.988 66.8486H107.408L113.148 9.3244H216.735L210.988 66.8486Z",
    fill: "url(#paint17_linear_1604_22911)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M210.988 66.8486H107.408L113.148 9.3244H216.735L210.988 66.8486Z",
    fill: "#F0F7FF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M204.272 26.0151H185.256L186.19 16.6426H205.212L204.272 26.0151Z",
    fill: "url(#paint18_linear_1604_22911)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M202.428 44.5034H183.406L184.347 35.1309H203.363L202.428 44.5034Z",
    fill: "url(#paint19_linear_1604_22911)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M200.578 62.9861H181.562L182.497 53.6136H201.519L200.578 62.9861Z",
    fill: "url(#paint20_linear_1604_22911)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M118.908 55.8069L118.854 56.3419H173.746L173.801 55.8069H118.908Z",
    fill: "url(#paint21_linear_1604_22911)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.801 55.8069H118.908L118.854 56.3419H173.746L173.801 55.8069Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M126.022 5.02863L105.791 71.3208H112.594L132.605 5.02863H126.022Z",
    fill: "#F0F7FF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M136.526 5.02863L116.295 71.3208H129.797L149.802 5.02863H136.526Z",
    fill: "#F0F7FF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M174.411 49.6924H119.586L122.902 16.5195H177.721L174.411 49.6924Z",
    fill: "url(#paint22_linear_1604_22911)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M121.093 62.7721C120.734 62.7778 120.377 62.7163 120.046 62.5916C119.716 62.467 119.419 62.2822 119.176 62.0494C118.934 61.8166 118.751 61.5411 118.639 61.2415C118.527 60.9418 118.49 60.6247 118.529 60.3113C118.606 59.6451 118.96 59.0268 119.522 58.5733C120.085 58.1199 120.818 57.8628 121.582 57.8505C121.942 57.8449 122.299 57.9064 122.629 58.031C122.96 58.1556 123.256 58.3405 123.499 58.5733C123.742 58.8061 123.925 59.0815 124.037 59.3812C124.148 59.6809 124.186 59.9979 124.147 60.3113C124.069 60.9776 123.716 61.5959 123.153 62.0493C122.591 62.5028 121.858 62.7599 121.093 62.7721Z",
    fill: "url(#paint23_linear_1604_22911)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M146.59 53.7688H119.184L119.391 51.6503H146.804L146.59 53.7688Z",
    fill: "url(#paint24_linear_1604_22911)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M146.59 53.7688H119.184L119.391 51.6503H146.804L146.59 53.7688Z",
    fill: "#F0F7FF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M173.208 61.3706H162.619L162.827 59.2468H173.422L173.208 61.3706Z",
    fill: "url(#paint25_linear_1604_22911)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M174.002 53.7688H171.584L171.792 51.6504H174.216L174.002 53.7688Z",
    fill: "url(#paint26_linear_1604_22911)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M169.899 53.7688H167.48L167.694 51.6504H170.112L169.899 53.7688Z",
    fill: "url(#paint27_linear_1604_22911)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M165.801 53.7688H163.377L163.591 51.6503H166.009L165.801 53.7688Z",
    fill: "url(#paint28_linear_1604_22911)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M177.928 14.4814H136.812L136.99 12.6518H178.111L177.928 14.4814Z",
    fill: "#F0F7FF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M133.563 14.6258H122.975L123.182 12.5073H133.777L133.563 14.6258Z",
    fill: "url(#paint29_linear_1604_22911)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.563 14.6258H122.975L123.182 12.5073H133.777L133.563 14.6258Z",
    fill: "#F0F7FF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M205.157 3.2338L205.152 3.76874L208.102 3.79038L208.107 3.25544L205.157 3.2338Z",
    fill: "url(#paint30_linear_1604_22911)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M194.313 3.19044L194.307 3.7254L202.862 3.80035L202.868 3.26539L194.313 3.19044Z",
    fill: "url(#paint31_linear_1604_22911)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M172.284 82.4534H175.588L169.506 141.395H166.373L172.284 82.4534Z",
    fill: "#263238"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.284 82.4534H175.588L169.506 141.395H166.373L172.284 82.4534Z",
    fill: "#F0F7FF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M171.959 110.784L171.354 110.854L175.652 139.376L176.257 139.306L171.959 110.784Z",
    fill: "#263238"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M167.937 138.223H66.1465L71.7157 82.4534H173.507L167.937 138.223Z",
    fill: "url(#paint32_linear_1604_22911)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M167.937 138.223H66.1465L71.7157 82.4534H173.507L167.937 138.223Z",
    fill: "#F0F7FF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4473 144.91H92.6608L99.5491 223.228H96.5019L88.4473 144.91Z",
    fill: "#263238"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M189.689 144.375H193.903L200.791 223.228H197.744L189.689 144.375Z",
    fill: "#263238"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M192.65 144.375H66.9883V156.791H192.65V144.375Z",
    fill: "url(#paint33_linear_1604_22911)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M170.581 144.471L170.086 156.781L192.65 156.791V144.375L170.581 144.471Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M168.671 144.466H67.0078V156.882H168.671V144.466Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7676 144.375H65.554L65.4258 223.228H68.4669L69.7676 144.375Z",
    fill: "#263238"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M171.01 144.375H166.796L166.674 223.228H169.715L171.01 144.375Z",
    fill: "#263238"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M65.554 144.375L65.4258 223.228H68.4669L69.7676 144.375H65.554Z",
    fill: "#F0F7FF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M171.01 144.375H166.796L166.674 223.228H169.715L171.01 144.375Z",
    fill: "#F0F7FF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0488 141.395C62.0488 139.721 62.7572 138.367 63.6365 138.362H195.82C196.699 138.362 197.408 139.721 197.408 141.395C197.408 143.064 196.699 144.418 195.82 144.423H63.6365C62.7572 144.418 62.0488 143.064 62.0488 141.395Z",
    fill: "#263238"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M62.0488 141.395C62.0488 139.721 62.7572 138.367 63.6365 138.362H195.82C196.699 138.362 197.408 139.721 197.408 141.395C197.408 143.064 196.699 144.418 195.82 144.423H63.6365C62.7572 144.418 62.0488 143.064 62.0488 141.395Z",
    fill: "#F0F7FF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M163.289 141.395C163.289 139.721 164.004 138.367 164.877 138.362H195.819C196.698 138.362 197.407 139.721 197.407 141.395C197.407 143.064 196.698 144.418 195.819 144.423H164.877C164.004 144.418 163.289 143.064 163.289 141.395Z",
    fill: "#263238"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M161.452 131.038H130.645L134.986 87.5302H165.8L161.452 131.038Z",
    fill: "#F0F7FF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M161.733 131.306H130.314L134.711 87.2628H166.142L161.733 131.306ZM130.974 130.771H161.177L165.452 87.7977H135.267L130.974 130.771Z",
    fill: "#F0F7FF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M140.72 129.097H133.215L133.673 124.469H141.178L140.72 129.097ZM133.545 128.829H140.439L140.848 124.737H133.954L133.545 128.829Z",
    fill: "#B3CCE5"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M149.856 129.097H142.326L142.79 124.469H150.295L149.856 129.097ZM142.68 128.829H149.575L149.984 124.737H143.089L142.68 128.829Z",
    fill: "#B3CCE5"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M158.985 129.097H151.486L151.95 124.469H159.425L158.985 129.097ZM151.816 128.829H158.704L159.113 124.737H152.225L151.816 128.829Z",
    fill: "#B3CCE5"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M159.943 117.9H134.473V118.167H159.943V117.9Z",
    fill: "#B3CCE5"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M151.834 111.673H134.998L135.163 109.972H152.011L151.834 111.673ZM135.346 111.405H151.584L151.7 110.239H135.432L135.346 111.405Z",
    fill: "#B3CCE5"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M159.644 122.538H152.652L152.823 120.853H159.809L159.644 122.538ZM152.988 122.27H159.363L159.473 121.12H153.104L152.988 122.27Z",
    fill: "#B3CCE5"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M160.297 115.969H157.641L157.873 113.642H160.529L160.297 115.969ZM157.976 115.701H160.034L160.212 113.909H158.172L157.976 115.701Z",
    fill: "#B3CCE5"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M148.75 115.969H146.094L146.326 113.642H148.982L148.75 115.969ZM146.424 115.701H148.469L148.646 113.909H146.601L146.424 115.701Z",
    fill: "#B3CCE5"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M137.203 115.969H134.547L134.779 113.642H137.441L137.203 115.969ZM134.877 115.701H136.922L137.099 113.909H135.054L134.877 115.701Z",
    fill: "#B3CCE5"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M144.927 91.5798H136.988L137.171 89.7823H145.11L144.927 91.5798ZM137.324 91.3123H144.652L144.774 90.0498H137.44L137.324 91.3123Z",
    fill: "#B3CCE5"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M136.378 123.009H135.706C135.471 123.011 135.238 122.97 135.023 122.889C134.807 122.807 134.613 122.687 134.453 122.536C134.294 122.384 134.172 122.206 134.097 122.011C134.021 121.816 133.993 121.609 134.015 121.404L134.076 120.821C134.125 120.387 134.354 119.984 134.72 119.688C135.086 119.392 135.563 119.224 136.06 119.216H136.726C136.962 119.213 137.195 119.253 137.412 119.334C137.628 119.415 137.823 119.536 137.983 119.687C138.143 119.838 138.265 120.017 138.341 120.213C138.417 120.408 138.445 120.615 138.424 120.821L138.363 121.404C138.313 121.838 138.084 122.241 137.718 122.537C137.353 122.832 136.876 123 136.378 123.009ZM136.06 119.462C135.639 119.47 135.235 119.613 134.925 119.863C134.615 120.113 134.419 120.453 134.375 120.821L134.32 121.404C134.298 121.574 134.318 121.746 134.378 121.908C134.438 122.071 134.537 122.22 134.668 122.347C134.799 122.473 134.96 122.574 135.139 122.642C135.318 122.71 135.511 122.744 135.706 122.741H136.378C136.799 122.733 137.203 122.59 137.513 122.34C137.823 122.09 138.019 121.75 138.063 121.382L138.118 120.799C138.138 120.629 138.117 120.456 138.056 120.293C137.995 120.13 137.896 119.98 137.764 119.852C137.632 119.727 137.472 119.628 137.293 119.56C137.114 119.493 136.921 119.46 136.726 119.462H136.06Z",
    fill: "#B3CCE5"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M161.006 108.543H135.285V108.399L136.83 92.8851H162.551V93.0296L161.006 108.543ZM135.615 108.276H160.725L162.234 93.1687H137.123L135.615 108.276Z",
    fill: "#B3CCE5"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M137.077 92.9272L136.896 93.1428L160.774 108.52L160.955 108.304L137.077 92.9272Z",
    fill: "#B3CCE5"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M149.769 100.088L135.369 108.302L135.536 108.526L149.936 100.312L149.769 100.088Z",
    fill: "#B3CCE5"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M140.489 129.07L133.723 124.71L133.906 124.496L140.672 128.856L140.489 129.07Z",
    fill: "#B3CCE5"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M140.938 124.489L133.303 128.844L133.469 129.068L141.104 124.713L140.938 124.489Z",
    fill: "#B3CCE5"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M149.624 129.07L142.857 124.71L143.041 124.496L149.807 128.856L149.624 129.07Z",
    fill: "#B3CCE5"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M150.07 124.485L142.436 128.842L142.602 129.066L150.236 124.709L150.07 124.485Z",
    fill: "#B3CCE5"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M158.754 129.07L151.994 124.71L152.177 124.496L158.937 128.856L158.754 129.07Z",
    fill: "#B3CCE5"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M159.203 124.488L151.568 128.844L151.735 129.068L159.369 124.712L159.203 124.488Z",
    fill: "#B3CCE5"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M126.778 121.634H69.834L73.2293 87.6371H130.173L126.778 121.634Z",
    fill: "#F0F7FF"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M127.061 121.901H69.5059L72.9561 87.3697H130.505L127.061 121.901ZM70.1715 121.366H126.499L129.839 87.9046H73.5118L70.1715 121.366Z",
    fill: "#F0F7FF"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M107.373 115.583H76.4609V115.851H107.373V115.583Z",
    fill: "#B3CCE5"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M108.032 110.646H76.8887V110.501L78.7634 91.7029H109.944V91.8473L108.032 110.646ZM77.1879 110.378H107.751L109.583 91.9704H79.0504L77.1879 110.378Z",
    fill: "#B3CCE5"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1266 119.617H77.2839C77.1148 119.619 76.9472 119.59 76.7916 119.532C76.6361 119.474 76.4959 119.388 76.3801 119.28C76.2665 119.169 76.1806 119.038 76.1281 118.896C76.0755 118.755 76.0573 118.605 76.0748 118.456L76.1481 117.718C76.1852 117.409 76.3497 117.123 76.6105 116.914C76.8714 116.704 77.2107 116.585 77.5648 116.579H78.4014C78.5709 116.578 78.7388 116.607 78.8944 116.666C79.05 116.725 79.1899 116.812 79.3052 116.921C79.4191 117.031 79.5056 117.16 79.5593 117.301C79.6129 117.442 79.6324 117.591 79.6166 117.739L79.5434 118.478C79.505 118.786 79.3401 119.071 79.0795 119.281C78.8189 119.49 78.4803 119.61 78.1266 119.617ZM77.5648 116.846C77.2869 116.85 77.0202 116.943 76.8154 117.108C76.6106 117.272 76.4818 117.497 76.4534 117.739L76.3801 118.478C76.3642 118.589 76.3759 118.701 76.4144 118.808C76.4529 118.915 76.5173 119.013 76.6031 119.096C76.689 119.179 76.7943 119.244 76.9118 119.288C77.0293 119.332 77.1562 119.353 77.2839 119.35H78.1266C78.4042 119.345 78.6701 119.251 78.8747 119.087C79.0792 118.922 79.2084 118.698 79.238 118.456L79.3113 117.718C79.3252 117.607 79.3119 117.494 79.2723 117.388C79.2327 117.282 79.1677 117.184 79.0816 117.102C78.9954 117.019 78.8902 116.954 78.773 116.91C78.6557 116.865 78.529 116.844 78.4014 116.846H77.5648Z",
    fill: "#B3CCE5"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2523 114.016H76.5156L76.6622 112.55H92.405L92.2523 114.016ZM76.8454 113.749H91.9714L92.0691 112.818H76.9431L76.8454 113.749Z",
    fill: "#B3CCE5"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M107.195 118.831H100.924L101.07 117.365H107.342L107.195 118.831ZM101.26 118.563H106.908L107.006 117.632H101.351L101.26 118.563Z",
    fill: "#B3CCE5"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M107.696 114.016H106.029L106.17 112.55H107.843L107.696 114.016ZM106.359 113.749H107.415L107.507 112.818H106.451L106.359 113.749Z",
    fill: "#B3CCE5"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M105.388 114.016H103.715L103.861 112.55H105.535L105.388 114.016ZM104.051 113.749H105.107L105.199 112.818H104.142L104.051 113.749Z",
    fill: "#B3CCE5"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M103.073 114.016H101.412L101.559 112.55H103.244L103.073 114.016ZM101.742 113.749H102.798L102.89 112.818H101.833L101.742 113.749Z",
    fill: "#B3CCE5"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M110.065 90.2852H86.6035L86.7318 88.9853H110.193L110.065 90.2852ZM86.9394 90.0178H109.784L109.864 89.2528H87.0127L86.9394 90.0178Z",
    fill: "#B3CCE5"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0837 90.3655H78.8184L78.9649 88.905H85.2303L85.0837 90.3655ZM79.1481 90.098H84.8028L84.9005 89.1725H79.2397L79.1481 90.098Z",
    fill: "#B3CCE5"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M124.795 97.8495H113.803L114.358 92.302H125.35L124.795 97.8495ZM114.114 97.5821H124.495L125.002 92.5695H114.621L114.114 97.5821Z",
    fill: "#B3CCE5"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M123.756 108.26H112.764L113.319 102.712H124.311L123.756 108.26ZM113.069 107.992H123.45L123.951 102.98H113.57L113.069 107.992Z",
    fill: "#B3CCE5"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M122.718 118.67H111.727L112.276 113.123H123.268L122.718 118.67ZM112.032 118.403H122.413L122.914 113.39H112.533L112.032 118.403Z",
    fill: "#B3CCE5"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M125.117 92.3084L113.883 97.5919L114.027 97.8276L125.261 92.5441L125.117 92.3084Z",
    fill: "#B3CCE5"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M124.58 97.8282L114.395 92.5535L114.547 92.3234L124.733 97.5981L124.58 97.8282Z",
    fill: "#B3CCE5"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M123.584 102.722L112.363 107.972L112.507 108.207L123.727 102.957L123.584 102.722Z",
    fill: "#B3CCE5"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M113.513 102.906L113.357 103.136L123.535 108.424L123.691 108.194L113.513 102.906Z",
    fill: "#B3CCE5"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M111.689 118.793L112.263 113.058L117.491 115.765L123.029 113.16L123.176 113.401L117.796 115.926L122.681 118.446L122.523 118.676L117.509 116.07L111.689 118.793ZM112.526 113.502L112.044 118.317L117.173 115.91L112.526 113.502Z",
    fill: "#B3CCE5"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M109.678 91.7209L76.9375 110.397L77.1041 110.621L109.845 91.945L109.678 91.7209Z",
    fill: "#B3CCE5"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9797 91.7247L78.7988 91.9402L107.804 110.619L107.984 110.403L78.9797 91.7247Z",
    fill: "#B3CCE5"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M112.168 205.617L111.496 218.654C111.496 218.654 116.992 220.147 117.529 218.162C117.877 216.942 118.916 212.695 119.85 209.383C120.21 208.126 119.85 206.917 119.117 206.446C117.902 205.665 115.832 205.681 112.168 205.617Z",
    fill: "#FF8B7B"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0144 204.948L72.3047 214.819C72.3047 214.819 75.5595 218.424 76.9213 216.958C78.7533 214.99 84.7316 208.57 84.7316 208.57C84.7316 208.57 86.8079 208.827 78.0144 204.948Z",
    fill: "#FF8B7B"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M75.3145 209.608L81.6287 211.93L84.169 209.196L76.9144 206.842L75.3145 209.608Z",
    fill: "black"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.924 210.416L111.766 213.417H118.758L119.613 210.416H111.924Z",
    fill: "black"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6328 128.957L78.3441 131.734L81.6173 129.626C81.6173 129.626 80.5303 125.48 80.0296 125.774L75.6328 128.385V128.957Z",
    fill: "#FF8B7B"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M75.6328 128.957L78.3441 131.734L81.6173 129.626C81.6173 129.626 80.5303 125.48 80.0296 125.774L75.6328 128.385V128.957Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2396 93.174L66.2767 102.621C65.5214 103.354 65.0455 104.275 64.9152 105.256C64.785 106.237 65.0069 107.229 65.55 108.094C68.5301 112.909 75.632 122.581 75.632 122.581L79.1128 120.387C79.1128 120.387 74.9359 109.565 73.226 107.302C73.1763 107.238 73.1562 107.16 73.1698 107.084C73.1834 107.007 73.2297 106.938 73.2993 106.89L83.424 99.5828L78.2396 93.174Z",
    fill: "#FF8B7B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.2396 93.174L66.2767 102.621C65.5214 103.354 65.0455 104.275 64.9152 105.256C64.785 106.237 65.0069 107.229 65.55 108.094C68.5301 112.909 75.632 122.581 75.632 122.581L79.1128 120.387C79.1128 120.387 74.9359 109.565 73.226 107.302C73.1763 107.238 73.1562 107.16 73.1698 107.084C73.1834 107.007 73.2297 106.938 73.2993 106.89L83.424 99.5828L78.2396 93.174Z",
    fill: "black"
  }))), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6328 122.538V128.353L80.5181 125.448C80.5181 125.448 80.8417 120.537 79.1014 120.345L75.6328 122.538Z",
    fill: "#FF8B7B"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M75.6328 122.538V128.353L80.5181 125.448C80.5181 125.448 80.8417 120.537 79.1014 120.345L75.6328 122.538Z",
    fill: "black"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M103.282 169.86C103.206 172.443 102.838 175.013 102.183 177.532C98.7024 190.419 84.9442 208.907 84.9442 208.907L76.9141 206.27C76.9141 206.27 88.254 179.522 89.5608 172.701C90.6234 167.138 80.8345 146.814 77.9949 138.555C75.9431 132.584 78.8315 127 78.8315 127C78.8315 127 86.2083 127.877 94.953 128.358L98.391 142.224L99.9787 148.644C101.165 152.224 102.043 155.878 102.605 159.573L102.678 160.055C102.739 160.472 102.8 160.884 102.849 161.285C103.225 164.131 103.37 166.997 103.282 169.86Z",
    fill: "url(#paint34_linear_1604_22911)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M103.282 169.86C103.206 172.443 102.838 175.013 102.183 177.532C98.7024 190.419 84.9442 208.907 84.9442 208.907L76.9141 206.27C76.9141 206.27 88.254 179.522 89.5608 172.701C90.6234 167.138 80.8345 146.814 77.9949 138.555C75.9431 132.584 78.8315 127 78.8315 127C78.8315 127 86.2083 127.877 94.953 128.358L98.391 142.224L99.9787 148.644C101.165 152.224 102.043 155.878 102.605 159.573L102.678 160.055C102.739 160.472 102.8 160.884 102.849 161.285C103.225 164.131 103.37 166.997 103.282 169.86Z",
    fill: "#F0F7FF"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M103.283 169.86C102.148 166.437 97.4882 156.278 91.3816 146.199C85.2201 136.035 91.9923 133.596 91.9923 133.596C94.5754 134.419 96.7005 137.816 98.392 142.224C100.389 147.43 101.781 154.068 102.606 159.573L102.679 160.055C102.74 160.472 102.801 160.884 102.85 161.285C103.226 164.131 103.371 166.997 103.283 169.86Z",
    fill: "#263238"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M108.883 130.177L88.0286 128.792C88.0286 128.792 86.5996 133.007 86.5996 136.051C86.5996 147.178 95.5641 146.633 98.3304 152.201C104.437 164.548 110.006 172.123 110.684 175.595C111.215 178.324 111.295 212.229 111.295 212.229H119.429C119.429 212.229 126.561 185.695 125.23 174.921C123.899 164.147 108.883 130.177 108.883 130.177Z",
    fill: "url(#paint35_linear_1604_22911)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.883 130.177L88.0286 128.792C88.0286 128.792 86.5996 133.007 86.5996 136.051C86.5996 147.178 95.5641 146.633 98.3304 152.201C104.437 164.548 110.006 172.123 110.684 175.595C111.215 178.324 111.295 212.229 111.295 212.229H119.429C119.429 212.229 126.561 185.695 125.23 174.921C123.899 164.147 108.883 130.177 108.883 130.177Z",
    fill: "#F0F7FF"
  }))), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M137.004 93.9711L149.12 99.3207C149.18 99.352 149.235 99.3898 149.285 99.433L150.072 100.225L148.949 100.193C148.875 100.192 148.802 100.177 148.735 100.15L136.412 95.1052C136.287 95.0538 136.189 94.9627 136.138 94.8505C136.087 94.7382 136.087 94.6132 136.137 94.5007L136.259 94.2386C136.285 94.1761 136.325 94.1191 136.378 94.0711C136.43 94.0232 136.494 93.9854 136.564 93.9602C136.634 93.935 136.71 93.923 136.785 93.9249C136.861 93.9267 136.936 93.9425 137.004 93.9711Z",
    fill: "url(#paint36_linear_1604_22911)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M139.189 98.4969L143.085 96.6566L142.444 101.573C142.444 101.573 139.244 103.221 137.309 101.498L139.189 98.4969Z",
    fill: "#FF8B7B"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M147.465 98.6306L147.16 100.198C147.111 100.443 146.975 100.668 146.771 100.84C146.567 101.012 146.305 101.123 146.024 101.156L142.445 101.573L143.087 96.6566L146.439 97.3039C146.771 97.3684 147.063 97.5417 147.253 97.7885C147.444 98.0352 147.52 98.3365 147.465 98.6306Z",
    fill: "#FF8B7B"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M109.572 98.3096C109.572 98.3096 112.742 112.267 120.015 114.583C126.561 116.664 139.714 102.279 139.714 102.279L139.189 98.4969L122.701 107.869L116.07 93.1633C113.802 94.7771 111.633 96.4949 109.572 98.3096Z",
    fill: "#FF8B7B"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1914 217.964C78.705 217.644 78.2533 217.286 77.8418 216.894C77.8229 216.875 77.8125 216.85 77.8125 216.825C77.8125 216.799 77.8229 216.774 77.8418 216.755C77.8544 216.733 77.8748 216.714 77.9001 216.703C77.9253 216.691 77.9541 216.687 77.9823 216.691C78.2815 216.734 80.8768 217.092 81.2066 217.729C81.2369 217.789 81.2494 217.854 81.243 217.92C81.2366 217.985 81.2115 218.048 81.1699 218.103C81.1061 218.198 81.0175 218.278 80.9112 218.336C80.805 218.395 80.6843 218.431 80.5593 218.44C80.0541 218.425 79.5705 218.257 79.1914 217.964ZM78.3242 216.98C79.2341 217.787 80.0402 218.231 80.5043 218.21C80.5867 218.205 80.6664 218.182 80.7358 218.143C80.8052 218.103 80.8622 218.049 80.9012 217.985C80.9163 217.964 80.9243 217.939 80.9243 217.913C80.9243 217.888 80.9163 217.863 80.9012 217.841C80.7486 217.477 79.3746 217.151 78.3242 216.98Z",
    fill: "url(#paint37_linear_1604_22911)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8554 216.905C77.8344 216.886 77.8178 216.865 77.8066 216.841C77.7963 216.822 77.791 216.802 77.791 216.782C77.791 216.761 77.7963 216.741 77.8066 216.723C77.8615 216.648 79.4676 215.118 80.524 215.776L80.6217 215.83C80.9026 216.044 80.8782 216.236 80.811 216.364C80.5118 216.899 78.6432 217.049 77.886 216.899L77.8554 216.905ZM80.4019 215.979C79.7241 215.546 78.6676 216.359 78.2279 216.718C79.0645 216.782 80.408 216.573 80.5851 216.257C80.5851 216.257 80.6584 216.167 80.4691 216.017L80.4019 215.979Z",
    fill: "url(#paint38_linear_1604_22911)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7723 214.337L69.0365 218.617C68.9254 218.801 68.9015 219.017 68.97 219.217C69.0385 219.417 69.194 219.586 69.4029 219.687C70.8868 220.446 72.8837 221.516 73.7508 221.859C78.227 223.619 80.8833 223.153 83.4176 223.105C83.623 223.088 83.8215 223.031 83.9983 222.938C84.1751 222.845 84.3257 222.718 84.4389 222.567C84.5521 222.416 84.625 222.244 84.6523 222.065C84.6795 221.886 84.6603 221.704 84.5962 221.532L84.4862 221.201C84.4431 221.063 84.3604 220.938 84.2459 220.837C84.1315 220.735 83.9892 220.662 83.8328 220.623C80.1689 219.772 78.0377 216.225 78.0377 216.225L72.9264 214.016C72.7233 213.932 72.4916 213.919 72.2776 213.979C72.0637 214.038 71.8832 214.166 71.7723 214.337Z",
    fill: "#263238"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M119.33 219.505C118.758 219.318 118.207 219.087 117.682 218.815C117.655 218.804 117.633 218.785 117.62 218.761C117.608 218.738 117.606 218.711 117.615 218.686C117.619 218.663 117.633 218.641 117.653 218.625C117.672 218.609 117.697 218.598 117.724 218.595C118.024 218.558 120.631 218.248 121.156 218.772C121.205 218.822 121.239 218.882 121.254 218.947C121.269 219.011 121.265 219.078 121.242 219.141C121.213 219.247 121.156 219.345 121.076 219.428C120.995 219.511 120.893 219.576 120.778 219.617C120.295 219.725 119.784 219.686 119.33 219.505ZM118.17 218.782C119.312 219.317 120.228 219.547 120.668 219.408C120.745 219.383 120.814 219.341 120.868 219.286C120.921 219.23 120.957 219.164 120.973 219.093C120.985 219.069 120.988 219.042 120.983 219.017C120.977 218.991 120.963 218.967 120.943 218.948C120.656 218.643 119.233 218.681 118.17 218.782Z",
    fill: "url(#paint39_linear_1604_22911)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M117.566 218.927L117.499 218.884C117.488 218.865 117.482 218.844 117.482 218.823C117.482 218.801 117.488 218.78 117.499 218.761C117.529 218.676 118.561 216.803 119.795 217.156L119.905 217.183C120.241 217.317 120.283 217.509 120.259 217.638C120.137 218.21 118.427 218.847 117.639 218.911L117.566 218.927ZM119.697 217.397C118.909 217.156 118.164 218.205 117.865 218.654C118.69 218.504 119.905 217.964 119.972 217.622C119.972 217.622 120.009 217.515 119.777 217.424L119.697 217.397Z",
    fill: "url(#paint40_linear_1604_22911)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M110.642 219.676C110.569 220.585 110.605 221.955 110.642 223.421C110.642 224.132 111.143 225.304 111.863 225.56C112.999 225.94 114.843 225.823 116.932 225.528C119.661 225.138 124.192 223.084 126.031 222.212C126.378 222.047 126.642 221.774 126.77 221.447C126.898 221.12 126.88 220.763 126.721 220.446C126.635 220.291 126.556 220.168 126.489 220.066C126.438 219.987 126.363 219.922 126.273 219.877C126.182 219.833 126.079 219.811 125.976 219.815C123.478 219.879 123.118 219.778 120.785 219.778C120.138 219.798 119.496 219.678 118.915 219.428C118.334 219.178 117.833 218.805 117.457 218.344C117.457 218.344 114.648 219.104 112.468 218.708C110.288 218.312 110.642 219.676 110.642 219.676Z",
    fill: "#263238"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6775 85.2887C87.3286 86.1561 85.0497 87.1624 82.8565 88.3005C80.7089 89.3235 78.7942 90.6835 77.2079 92.3127C76.7902 92.6894 76.5578 93.1945 76.5606 93.7197C76.6302 94.0272 76.7761 94.3176 76.988 94.5703C78.8496 97.1069 81.2528 99.3048 84.0656 101.043C84.7489 97.3761 86.198 93.8506 88.3402 90.6436C89.3661 89.0976 90.5874 87.5569 90.7828 85.7809L89.6775 85.2887Z",
    fill: "url(#paint41_linear_1604_22911)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M120.588 74.7233C120.534 75.8938 120.661 77.0654 120.967 78.2059C120.063 78.4733 119.086 77.7779 119.086 77.7779L120.588 74.7233Z",
    fill: "#A02724"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M119.892 77.7832C119.737 77.7854 119.582 77.7656 119.434 77.7244C118.335 77.4408 117.792 76.189 118.213 74.9265C118.634 73.664 119.874 72.8723 120.967 73.1558C121.255 73.2324 121.518 73.3701 121.731 73.5568C121.944 73.7434 122.101 73.9732 122.188 74.2257C122.393 74.7822 122.393 75.3811 122.188 75.9376C121.834 77.0129 120.869 77.7832 119.892 77.7832ZM120.503 73.3644C119.672 73.3644 118.824 74.0278 118.5 75.0014C118.121 76.1195 118.573 77.2268 119.508 77.4676C119.628 77.4996 119.754 77.5158 119.88 77.5157C120.723 77.5157 121.565 76.831 121.883 75.8787C122.066 75.3741 122.066 74.832 121.883 74.3274C121.811 74.1151 121.683 73.9211 121.507 73.7618C121.332 73.6026 121.115 73.4828 120.875 73.4126C120.759 73.3816 120.637 73.3654 120.515 73.3644H120.503Z",
    fill: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M105.261 74.0118L107.288 77.6442L110.061 82.6032C109.569 82.9487 109.155 83.3714 108.84 83.8497C108.052 84.8822 107.435 85.6258 109.841 87.5195C110.103 87.7104 110.296 87.9633 110.398 88.2479C110.5 88.5325 110.506 88.8368 110.415 89.1244C110.159 89.8252 109.255 90.4136 106.458 89.6593C103.77 88.8915 101.432 87.3922 99.7835 85.3797C98.9652 84.4221 99.2888 83.8497 100.303 83.074C103.246 80.9449 104.553 77.1306 105.261 74.0118Z",
    fill: "#FF8B7B"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M118.837 79.6181C118.156 80.5317 117.245 81.2961 116.174 81.8526C115.102 82.4091 113.899 82.7427 112.658 82.8279C111.813 82.8892 110.962 82.8259 110.142 82.6406C109.145 82.4142 108.219 81.9968 107.429 81.4186C106.639 80.8404 106.005 80.1158 105.574 79.2971C103.827 76.0874 105.012 73.3805 106.557 68.598C106.908 67.481 107.574 66.4595 108.495 65.6279C109.415 64.7962 110.56 64.1814 111.824 63.8401C113.087 63.4988 114.429 63.4422 115.724 63.6753C117.019 63.9085 118.227 64.424 119.234 65.1742C123.735 68.6033 121.677 75.7557 118.837 79.6181Z",
    fill: "#FF8B7B"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M112.656 82.8493C111.811 82.9106 110.961 82.8473 110.14 82.662L110.061 82.6032L110.891 81.8703C110.891 81.8703 110.934 82.7048 112.656 82.8493Z",
    fill: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M110.225 62.6225C110.055 62.2496 109.751 61.9358 109.358 61.729C108.965 61.5222 108.506 61.4339 108.051 61.4777C108.718 61.8609 109.224 62.4244 109.492 63.0825L110.225 62.6225Z",
    fill: "#263238"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M126.977 70.4168C125.548 71.7328 121.86 71.1765 121.86 71.1765L120.303 69.8391C119.954 69.5716 119.234 69.2774 118.727 70.8234L118.037 72.134C118.037 72.134 116.242 74.7126 113.561 75.9537C113.182 76.1302 112.126 76.7721 112.126 76.7721C111.211 77.292 110.152 77.5858 109.063 77.6226C107.973 77.6593 106.892 77.4376 105.934 76.9808L105.219 76.7347C104.86 76.6109 104.548 76.3996 104.32 76.1257C104.093 75.8518 103.96 75.5267 103.937 75.1887C103.766 72.546 103.607 66.0516 106.062 63.9545C108.315 62.0073 109.524 62.6225 110.337 62.4299C111.247 61.9948 112.249 61.7276 113.281 61.6448C114.313 61.562 115.354 61.6653 116.339 61.9484C122.373 63.7673 122.147 66.8914 123.362 66.7363C124.098 66.6327 124.775 66.3186 125.286 65.8429C125.182 65.9981 123.881 67.8223 124.498 67.8811C125.115 67.94 126.763 66.6775 126.623 67.0412C126.482 67.405 124.705 69.0099 125.78 69.4058C126.751 69.7642 128.351 68.4963 128.351 68.4963C128.351 68.4963 128.412 69.0955 126.977 70.4168Z",
    fill: "#263238"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M115.322 71.2899L115.154 71.5136L122.463 75.7098L122.63 75.4861L115.322 71.2899Z",
    fill: "black"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M112.369 73.0328C112.234 74.1408 112.571 75.2534 113.315 76.157C114.286 77.3125 115.972 76.5315 116.448 75.1887C116.876 73.9797 116.576 72.0645 115.227 71.4012C113.877 70.7378 112.54 71.658 112.369 73.0328Z",
    fill: "#FF8B7B"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6767 85.2888C89.6767 85.2888 83.8816 91.2803 82.0068 105.189C80.1321 119.098 78.6055 128.423 78.6055 128.423L109.138 130.327C109.138 130.327 107.978 121.388 109.138 114.524C110.299 107.661 118.091 91.3178 116.369 88.6858C115.495 87.3484 108.888 84.7859 102.611 84.4061C96.5283 84.0209 89.6767 85.2888 89.6767 85.2888Z",
    fill: "#263238"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M108.741 88.1722C107.123 89.44 106.213 91.2535 105.566 93.0617C105.253 93.8046 105.1 94.5917 105.114 95.3834C105.272 96.4029 105.674 97.3818 106.293 98.2562L109.151 103.012C112.665 102.903 116.129 102.238 119.373 101.049C119.8 100.945 120.164 100.699 120.387 100.364C120.698 99.7219 118.787 94.6452 118.555 92.6444C117.969 88.3755 113.016 84.7805 108.741 88.1722Z",
    fill: "url(#paint42_linear_1604_22911)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5293 84.4649L99.0574 82.7423C99.6535 82.3357 100.398 82.1323 101.152 82.1699C102.911 82.2501 106.41 82.2501 109.378 83.2398C112.071 84.1546 111.497 86.1553 111.497 86.1553C111.497 86.1553 106.343 84.3258 96.5293 84.4649Z",
    fill: "url(#paint43_linear_1604_22911)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0333 125.716C77.3418 127.358 77.3418 132.424 77.3418 132.424C77.3418 132.424 93.0785 133.772 100.107 133.772C102.813 133.768 105.516 133.609 108.198 133.296L108.663 130.311L109.658 133.082L111.056 132.809L108.84 127.042L79.0333 125.716Z",
    fill: "url(#paint44_linear_1604_22911)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8017 208.923C86.8383 208.923 85.1163 211.598 85.1163 211.598L75.3457 208.217L76.1701 205.612L86.8017 208.923Z",
    fill: "url(#paint45_linear_1604_22911)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M121.346 209.324C121.389 209.324 120.736 212.219 120.736 212.219H110.324L110.043 209.544L121.346 209.324Z",
    fill: "url(#paint46_linear_1604_22911)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1604_22911",
    x1: 192.832,
    y1: 144.279,
    x2: 252.279,
    y2: 139.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1604_22911",
    x1: 199.416,
    y1: 130.043,
    x2: 210.754,
    y2: 127.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1604_22911",
    x1: 212.094,
    y1: 130.043,
    x2: 223.437,
    y2: 127.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1604_22911",
    x1: 224.777,
    y1: 130.043,
    x2: 236.121,
    y2: 127.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1604_22911",
    x1: 200.9,
    y1: 115.139,
    x2: 201.637,
    y2: 109.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1604_22911",
    x1: 233.26,
    y1: 112.561,
    x2: 237.124,
    y2: 112.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1604_22911",
    x1: 217.225,
    y1: 112.561,
    x2: 221.089,
    y2: 112.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1604_22911",
    x1: 201.188,
    y1: 112.561,
    x2: 205.052,
    y2: 112.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1604_22911",
    x1: 226.48,
    y1: 120.2,
    x2: 234.702,
    y2: 115.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1604_22911",
    x1: 201.799,
    y1: 106.591,
    x2: 211.615,
    y2: 94.1041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1604_22911",
    x1: 204.436,
    y1: 80.1797,
    x2: 213.58,
    y2: 75.0848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1604_22911",
    x1: 200.531,
    y1: 121.591,
    x2: 206.699,
    y2: 120.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1604_22911",
    x1: 202.141,
    y1: 102.996,
    x2: 242.182,
    y2: 95.3272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1604_22911",
    x1: 247.611,
    y1: 86.3683,
    x2: 246.684,
    y2: 83.9565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1604_22911",
    x1: 248.011,
    y1: 81.508,
    x2: 244.296,
    y2: 78.2776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1604_22911",
    x1: 107.408,
    y1: 66.8486,
    x2: 223.667,
    y2: 42.7058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1604_22911",
    x1: 102.709,
    y1: 71.3483,
    x2: 229.154,
    y2: 46.7117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1604_22911",
    x1: 107.408,
    y1: 66.8486,
    x2: 223.667,
    y2: 42.7058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1604_22911",
    x1: 185.256,
    y1: 26.0151,
    x2: 206.256,
    y2: 21.1293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1604_22911",
    x1: 183.406,
    y1: 44.5034,
    x2: 204.406,
    y2: 39.6175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1604_22911",
    x1: 181.563,
    y1: 62.9861,
    x2: 202.563,
    y2: 58.1003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1604_22911",
    x1: 118.854,
    y1: 56.3419,
    x2: 119.334,
    y2: 50.9538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1604_22911",
    x1: 119.586,
    y1: 49.6924,
    x2: 181.792,
    y2: 37.7806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1604_22911",
    x1: 118.514,
    y1: 62.7725,
    x2: 124.682,
    y2: 61.9992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1604_22911",
    x1: 119.184,
    y1: 53.7688,
    x2: 129.297,
    y2: 39.3614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1604_22911",
    x1: 162.619,
    y1: 61.3706,
    x2: 171.774,
    y2: 56.2824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1604_22911",
    x1: 171.584,
    y1: 53.7688,
    x2: 174.451,
    y2: 53.3797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1604_22911",
    x1: 167.48,
    y1: 53.7688,
    x2: 170.347,
    y2: 53.3797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1604_22911",
    x1: 163.377,
    y1: 53.7688,
    x2: 166.244,
    y2: 53.3796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1604_22911",
    x1: 122.975,
    y1: 14.6258,
    x2: 132.119,
    y2: 9.5308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1604_22911",
    x1: 208.102,
    y1: 3.79038,
    x2: 208.094,
    y2: 3.19715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1604_22911",
    x1: 202.862,
    y1: 3.80035,
    x2: 202.863,
    y2: 3.20693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1604_22911",
    x1: 66.1465,
    y1: 138.223,
    x2: 180.192,
    y2: 114.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1604_22911",
    x1: 66.9883,
    y1: 156.791,
    x2: 129.696,
    y2: 87.4466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1604_22911",
    x1: 76.9141,
    y1: 208.907,
    x2: 106.155,
    y2: 207.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1604_22911",
    x1: 86.5996,
    y1: 212.229,
    x2: 129.524,
    y2: 210.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1604_22911",
    x1: 136.1,
    y1: 100.225,
    x2: 150.739,
    y2: 96.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1604_22911",
    x1: 77.8125,
    y1: 218.44,
    x2: 81.4526,
    y2: 217.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1604_22911",
    x1: 77.791,
    y1: 216.954,
    x2: 80.9905,
    y2: 216.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1604_22911",
    x1: 117.609,
    y1: 219.677,
    x2: 121.262,
    y2: 218.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1604_22911",
    x1: 117.482,
    y1: 218.927,
    x2: 120.484,
    y2: 218.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1604_22911",
    x1: 76.5605,
    y1: 101.043,
    x2: 92.1848,
    y2: 99.5021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1604_22911",
    x1: 105.113,
    y1: 103.012,
    x2: 121.914,
    y2: 101.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1604_22911",
    x1: 96.5293,
    y1: 86.1553,
    x2: 110.778,
    y2: 80.2947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1604_22911",
    x1: 77.3418,
    y1: 133.772,
    x2: 108.273,
    y2: 119.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1604_22911",
    x1: 75.3457,
    y1: 211.598,
    x2: 87.5216,
    y2: 209.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1604_22911",
    x1: 110.043,
    y1: 212.219,
    x2: 120.651,
    y2: 207.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrototyping);
export default __webpack_public_path__ + "static/media/Prototyping.3f7f6d186f446e6fec69299fea276559.svg";
export { ForwardRef as ReactComponent };